module.exports = __webpack_public_path__ + "img/shareT2.005acfbb.svg";